import './panel.css';

const Panel = ({ children }: React.PropsWithChildren<unknown>) => {
    return <div className="scoped-panel">{children}</div>;
};

Panel.displayName = 'Panel';

export { Panel };
